module.exports = __webpack_public_path__ + "static/media/member8.3e530a2f.png";